import * as React from "react";
import PropTypes from "prop-types";
import EditableText from "nx-components/EditableText";
import Dispatch from "nexia_mobile/flux_like/dispatch";

export default class ResourceNameEditor extends React.Component {
  static propTypes = {
    initialValue: PropTypes.string.isRequired,
    resourceHref: PropTypes.string,
    onEditEnd: PropTypes.func,
  };

  state = { value: this.props.initialValue };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValue !== this.props.initialValue) {
      this.setState({ value: nextProps.initialValue });
    }
  }

  _handleChange = (value) => {
    this.setState({ value });
  };

  _handleEditEnd = () => {
    const { value } = this.state;
    const { initialValue, resourceHref, onEditEnd } = this.props;
    if (value === "") {
      this.setState({ value: initialValue });
      return;
    }
    if (onEditEnd) {
      onEditEnd(value);
    }
    if (!resourceHref) {
      Dispatch("SHOW_TOAST", "Change could not be saved.");
      this.setState({ value: initialValue });
      return;
    }
    if (initialValue !== value) {
      Dispatch("RESOURCE_CHANGE_NAME_REQUEST", resourceHref, value);
    }
  };

  render() {
    const { value } = this.state;

    return (
      <EditableText
        value={value}
        inputSize={16}
        maxTextLength={32}
        maxWidth={275}
        onChange={this._handleChange}
        onEditEnd={this._handleEditEnd}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/ResourceNameEditor.jsx